import { useEffect, useState } from "react";
import { checkFreeBuddyCode } from "./api";

const STORAGE = "pb_free_code";

// Reads ?free=CODE (from the QR) or a code remembered this session, and keeps it only if the server says it's active.
export default function useFreeBuddyCode() {
  const [code, setCode] = useState(null);

  useEffect(() => {
    const fromUrl = new URLSearchParams(window.location.search).get("free");
    const candidate = (fromUrl || sessionStorage.getItem(STORAGE) || "").trim().toUpperCase();
    if (!candidate) return;
    checkFreeBuddyCode(candidate)
      .then(({ valid }) => {
        if (valid) {
          sessionStorage.setItem(STORAGE, candidate);
          setCode(candidate);
        } else {
          sessionStorage.removeItem(STORAGE);
        }
      })
      .catch(() => {});
  }, []);

  const forget = () => sessionStorage.removeItem(STORAGE);
  const clear = () => {
    forget();
    setCode(null);
  };
  return { code, forget, clear };
}
